import React from "react";

import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from "react-chartjs-2";

import "./Charts.css";

ChartJS.register(CategoryScale, LinearScale, BarElement, PointElement, Title, Tooltip, Legend);

const COLORS = {
    good: { border: "#BBDEFB", background: "#BBDEFB" },
    great: { border: "#90CAF9", background: "#90CAF9" },
    excellent: { border: "#64B5F6", background: "#64B5F6" },
};

const NotesChartBar = ({ usuarioId, actorsResults = [] }) => {
    const groupedScores = actorsResults.reduce(
        (acc, actor) => {
            if (actor.usuarioId === usuarioId) {
                const score = parseFloat(actor.nota);
                const category = score < 70 ? "good" : score <= 80 ? "great" : "excellent";
                acc[category].push({ x: score, y: actor.estacao });
            }
            return acc;
        },
        { good: [], great: [], excellent: [] }
    );

    if (!groupedScores.good.length && !groupedScores.great.length && !groupedScores.excellent.length) {
        return null; // Retorno mais seguro
    }

    const labels = [...new Set(actorsResults.map(actor => actor.estacao))];

    const data = {
        labels,
        datasets: [
            {
                label: "BOM",
                data: groupedScores.good,
                borderColor: COLORS.good.border,
                backgroundColor: COLORS.good.background,
            },
            {
                label: "ÓTIMO",
                data: groupedScores.great,
                borderColor: COLORS.great.border,
                backgroundColor: COLORS.great.background,
            },
            {
                label: "EXCELENTE",
                data: groupedScores.excellent,
                borderColor: COLORS.excellent.border,
                backgroundColor: COLORS.excellent.background,
            }
        ]
    };

    const options = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            bar: {
                borderWidth: 2
            },
        },
        plugins: {
            legend: {
                labels: {
                    color: "#000000",
                },
                position: 'top',
                color: '#000000'
            },
            title: {
                display: true,
                text: 'Onde Podemos Melhorar? Comparativo de Resultados',
                color: '#000000'
            },
        },
        scales: {
            x: {
                grid: {
                    color: '#E3F2FD',
                },
                ticks: {
                    color: '#000000',
                },
                beginAtZero: true
            },
            y: {
                grid: {
                    color: '#E3F2FD',
                },
                ticks: {
                    color: '#000000',
                },
                type: "category"
            }
        },
    };

    return <Bar data={data} options={options} />;
};

export default NotesChartBar;